<template>
  <div class="operation-edit__wrapper">
    <div class="title">
      {{ $l('operation_title_group_info') || '分组信息' }}
    </div>
    <div>
      <el-form ref="form" :model="formData" :rules="rules" size="mini">
        <el-row>
          <el-col :span="24">
            <el-form-item
              :label="$l('form_label_groupTitle') || '分组名称'"
              prop="groupTitle"
            >
              <el-input
                v-model="formData.groupTitle"
                :placeholder="
                  $l('tips_placeholder_placeholder') || '请输入分组名称'
                "
                maxlength="50"
                clearable
                size="small"
                style="width: 100%"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item
              :label="$l('form_label_groupDesc') || '整体要求'"
              prop="groupDesc"
            >
              <el-input
                v-model="formData.groupDesc"
                :placeholder="
                  $l('form_placeholder_groupDesc') || '请输入整体要求'
                "
                type="textarea"
                :rows="3"
                maxlength="200"
                show-word-limit
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div style="display: flex;justify-content: flex-end;">
        <el-button type="primary" size="small" @click="save()">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </div>
    </div>
    <div>
      <ArtworkForm
        :evgPackingSchemeGroupCode="evgPackingSchemeGroupCode"
        :evgPackingSchemeCode="evgPackingSchemeCode"
        @reload="$emit('reload')"
      ></ArtworkForm>
    </div>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import ArtworkForm from '../artwork/ArtworkForm'
export default {
  mixins: [EditLoading],
  props: {
    evgPackingSchemeCode: { type: String, default: '' },
    evgPackingSchemeGroupCode: { type: String, default: '' },
  },
  components: { ArtworkForm },
  data() {
    return {
      formData: {},
      rules: {
        groupTitle: [
          {
            required: true,
            message:
              this.$l('tips_placeholder_placeholder') || '请输入分组名称',
            trigger: 'change',
          },
        ],
        groupDesc: [
          {
            required: true,
            message: this.$l('form_placeholder_groupDesc') || '请输入整体要求',
            trigger: 'change',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.evgPackingSchemeGroupCode) return
      this.$api
        .ecomEvgPackingSchemeDescGroupDetailApi({
          evgPackingSchemeGroupCode: this.evgPackingSchemeGroupCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return
      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomEvgPackingSchemeDescGroupSaveApi({
          ...this.formData,
          evgPackingSchemeCode: this.evgPackingSchemeCode,
          evgPackingSchemeGroupCode: this.evgPackingSchemeGroupCode,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || res.msg,
        type: 'success',
      })
      if (!this.evgPackingSchemeGroupCode) {
        this.$emit('updateCode', res.body)
      }
      this.$emit('reload')
    },
  },
}
</script>
<style lang="scss" scoped>
.operation-edit__wrapper {
  margin-top: 20px;
  .title {
    font-size: 16px;
    color: #101010;
    font-weight: 600;
    margin-bottom: 15px;
  }
}
</style>
